import {
  WB_LoaderKeyMapRow,
  WB_LoaderMetricMapRow,
  WB_LoaderMetricTermRow,
  WB_MetricDefinitionRow
} from "../PA.Core/PAdbSchemaRows";
import {BehaviorSubject} from "rxjs";
import {LoaderBO} from "../PA.Loader.BusinessObjects/LoaderBO";

export interface ILoaderStartOptions {
  [id:string]:any
}


export interface ILoaderStartStopResponse {
  bSuccess: boolean,
  sErrors: string[],
  sWarnings: string[]
}

export enum LoaderStatus {
  Idle="Idle",
  NotStarted="NotStarted",
  Starting="Starting",
  Running="Running",
  Stopping="Stopping",
  Stopped="Stopped",
  RunningWithErrors="RunningErrors",
  CompletedWithErrors="CompletedErrors",
  CompletedSuccess="CompletedSuccess"
}

export interface ILoaderStatus {
  Status: LoaderStatus,
  StartTime: Date,
  EndTime: Date,
  ErrorTime: Date,
  sErrors: string[],
  sWarnings: string[]
}

export interface ILoaderService {
  startLoader(aWB_Loader_ID: number, options?: ILoaderStartOptions): Promise<ILoaderStartStopResponse>
  stopLoader(aWB_Loader_ID: number): Promise<ILoaderStartStopResponse>
  getLoaderStatus(aWB_Loader_ID: number): Promise<ILoaderStatus>
}

export interface IHaveMetricDefinitions {
  readonly MetricDefinitions: Promise<WB_MetricDefinitionRow[]>
}


export interface IHaveLoaderKeyMaps {
  addKeyMap(dimId: string | string[], opts?: any): Promise<WB_LoaderKeyMapRow[]>
  removeKeyMap(wbLoaderKeyMapId: number): Promise<void>
  readonly OnKeyMapsCollectionChanged: BehaviorSubject<LoaderBO>
}

export interface IHaveLoaderMetricMaps {
  readonly MetricDefinitions: Promise<WB_MetricDefinitionRow[]>
  addMetricMap(wbMetricId: number | number[], opts?: any): Promise<WB_LoaderMetricMapRow[]>
  removeMetricMap(wbLoaderMetricMapId: number): Promise<void>
  readonly OnMetricMapsCollectionChanged: BehaviorSubject<LoaderBO>
}


export interface IHaveLoaderMetricTerms {
  addMetricTerm(wbLoaderMetricMapRow: WB_LoaderMetricMapRow, opts?: any): Promise<WB_LoaderMetricTermRow>
  removeMetricTerm(wbLoaderMetricMapRow: WB_LoaderMetricMapRow, wbLoaderMetricTermId: number): Promise<void>
  readonly OnMetricTermsCollectionChanged: BehaviorSubject<LoaderBO>
}
